import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { FONT } from '../Email/emailShared';

export { FONT, Progress, authToken, fmtDateTime, pct } from '../Email/emailShared';

export const SMS_STATUS = {
  pending: { label: 'Starting', bg: '#fef3c7', fg: '#92400e' },
  scheduled: { label: 'Scheduled', bg: '#dbeafe', fg: '#1d4ed8' },
  running: { label: 'Sending', bg: '#dcfce7', fg: '#166534' },
  completed: { label: 'Completed', bg: '#d1fae5', fg: '#065f46' },
  cancelled: { label: 'Stopped', bg: '#fee2e2', fg: '#991b1b' },
};
export const SMS_LOG_STATUS = {
  pending: { label: 'Waiting', bg: '#fef3c7', fg: '#92400e' },
  sent: { label: 'Sent', bg: '#dcfce7', fg: '#166534' },
  failed: { label: 'Failed', bg: '#fee2e2', fg: '#991b1b' },
};

export const SmsChip = ({ status, map = SMS_STATUS }) => {
  const s = map[status] || { label: status || '-', bg: '#f1f5f9', fg: '#475569' };
  return <Chip size="small" label={s.label} sx={{ fontFamily: FONT, fontWeight: 700, height: 24, background: s.bg, color: s.fg }} />;
};

// A valid Indian mobile number: 10 digits starting 6-9 (a leading 91 / +91 / 0 is ignored).
export const cleanMobile = (m) => String(m || '').replace(/\D/g, '').slice(-10);
export const validMobile = (m) => /^[6-9]\d{9}$/.test(cleanMobile(m));

// Replace ##var## placeholders with the entered values (left visible while still empty).
export const fillTemplate = (content = '', values = {}) =>
  content.replace(/##\s*([\w.-]+)\s*##/g, (all, name) => (values[name] ? values[name] : all));

// Variables found in a template text, e.g. "Hi ##name##, ..." -> ["name"]
export const detectVariables = (content = '') => [...new Set([...content.matchAll(/##\s*([\w.-]+)\s*##/g)].map((m) => m[1]))];

// Standard SMS: 160 characters (153 per part once split). Non-Latin characters: 70 (67 per part).
export const smsParts = (text = '') => {
  const unicode = Array.from(text).some((ch) => ch.charCodeAt(0) > 127);
  const single = unicode ? 70 : 160;
  const multi = unicode ? 67 : 153;
  const len = text.length;
  return { length: len, unicode, parts: len === 0 ? 0 : len <= single ? 1 : Math.ceil(len / multi) };
};

// The message as it will look on a phone.
export const PhoneBubble = ({ text, empty = 'Your message appears here' }) => (
  <Box sx={{ background: '#e2e8f0', borderRadius: '22px', p: 2 }}>
    <Box sx={{ background: '#fff', borderRadius: '16px 16px 16px 4px', p: 1.75, boxShadow: '0 1px 2px rgba(15,23,42,.1)' }}>
      <Typography sx={{ fontFamily: FONT, fontSize: 12.5, color: text ? '#0f172a' : '#94a3b8', lineHeight: 1.55, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {text || empty}
      </Typography>
    </Box>
  </Box>
);
